import React from "react";

const LoveIcon = (props) => {
	const id = Math.random().toString(36).substring(2, 15);
	const clipPathId = `clip0_${id}`;
	const gradientId = `paint0_linear_${id}`;

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="19"
			viewBox="0 0 18 19"
			fill="none"
			{...props}>
			<g clipPath={`url(#${clipPathId})`}>
				<path
					d="M2.07912 4.05959C0.30696 5.83174 0.306962 8.70498 2.07912 10.4771L8.95275 17.3508L8.99999 17.3035L9.0473 17.3508L15.9209 10.4772C17.6931 8.70504 17.6931 5.8318 15.9209 4.05964C14.1488 2.28749 11.2755 2.28749 9.50338 4.05965L9.3536 4.20942C9.15834 4.40468 8.84176 4.40468 8.6465 4.20942L8.49667 4.05959C6.72451 2.28743 3.85127 2.28743 2.07912 4.05959Z"
					fill={`url(#${gradientId})`}
				/>
			</g>
			<defs>
				<linearGradient
					id={gradientId}
					x1="9.00002"
					y1="2.73047"
					x2="9.00002"
					y2="17.3508"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#F0052F" />
					<stop
						offset="1"
						stopColor="#940136"
					/>
				</linearGradient>
				<clipPath id={clipPathId}>
					<rect
						width="18"
						height="18"
						fill="white"
						transform="translate(0 0.480469)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default LoveIcon;
